/* eslint-disable max-len */
import { AppIntegrationsRepository, ActivationCodesRepository, FlexiblePromotionsRepository, MeRepository, AppPricesRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import eventManager from 'common/services/-RFC.eventManager';

/**
 * Subscription confirmation controller
 * Handles subscription on/off modal template.
 */

angular.module('controllers')
    .controller(
        'SubscriptionConfirmation',
        (
            $scope, $stateParams, $window, Util, ActivationCodeRestService,
            $sce, FlexiblePromotionsRestService, ErrorHandler, $filter, $rootScope,
            AppPricesRestService, $http, $timeout,
        ) => {

            const key = $stateParams.resourceId;
            $scope.activationCode = ActivationCodesRepository.getById(key);
            const subscriptionRuntime = $scope.activationCode.attributes.runtime;
            $scope.loading = false;
            $scope.surveyFlow = false;
            $scope.showSurveyScreen = false;
            $scope.showSuccessScreen = false;
            $scope.showDiscountScreen = false;
            $scope.isLoading = true;
            $scope.showDiscountAddedScreen = false;
            $scope.showDiscountAdded = false;
            $scope.expireDate = Util.deepFind($scope.activationCode, 'attributes.date_expire');
            $scope.nextBillingEvent = Util.deepFind($scope.activationCode, 'attributes.next_billing_event');
            $scope.showDiscountCard = false;
            $scope.isAnimationEnable = localStorage.getItem('animation') === 'true' && CWCONFIG.unsubscribeAnimation;
            $scope.animationDuration = 700;
            $scope.showOptions = true;
            $scope.submitted = false;
            $scope.discountFreeDays = CWCONFIG.discountFreeDays10;
            $scope.showSurveyModal = false;
            $scope.showBenefitsModal = false;
            $scope.showSuccessCancellationScreen = false;
            $scope.showUnsubscribeFeedbackModal = false;
            $scope.showDiscountModal = false;
            $scope.showFeedbackModalFirst = false;

            // CMA Links
            const currentLanguage = CWCONFIG.language;

            $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
            $scope.renewalPrices = CWCONFIG.cma.subscriptions.renewalPrices;
            $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
            $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
            $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
            $scope.cancellation = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
            // End CMA links

            if (!$rootScope.cmaGBapplies && !$rootScope.cmaUSapplies &&
                 Util.getDeviceNavigator() !== 'android' && Util.getDeviceNavigator() !== 'ios') {

                $scope.showCloseButton = true;

                $scope.onCloseButtonClick = (modalDetail) => {

                    Mixpanel.send('ConnectWeb Modal Button Click', {
                        Modal: 'Subscription Confirmation',
                        'Button Label': 'Close-Button-Unsubscribe',
                        'Modal Detail': modalDetail,
                    });
                    $scope.closeModal();

                };

            }

            $scope.formattedexpireDate = moment($scope.expireDate).format('L');

            if (!$rootScope.cmaGBapplies) {

                $scope.acceptedRowTerms = false;

                $scope.onChangeCheckboxROW = () => {

                    $scope.acceptedRowTerms = !$scope.acceptedRowTerms;

                };


            } else {

                $scope.acceptedGbTerms1 = false;
                $scope.acceptedGbTerms2 = false;

                $scope.onChangeCheckboxGB1 = () => {

                    $scope.acceptedGbTerms1 = !$scope.acceptedGbTerms1;

                };
                $scope.onChangeCheckboxGB2 = () => {

                    $scope.acceptedGbTerms2 = !$scope.acceptedGbTerms2;

                };

            }

            const subscriptionTypeValue = Util.deepFind($scope.activationCode, 'attributes.subscription_type');
            if (subscriptionTypeValue === 'yearly' || subscriptionTypeValue === 'annual' || subscriptionTypeValue === 'annual-trial') {

                $scope.showAnnual = true;

            } else if (subscriptionTypeValue === 'monthly' || subscriptionTypeValue === 'monthly-trial') {

                $scope.showMonthly = true;

            }

            let devices = 1;

            if ($scope.activationCode.attributes.max_activations) {

                devices = $scope.activationCode.attributes.max_activations;

            }

            let runtime = 12;
            if ($scope.activationCode.attributes.runtime === 1) {

                runtime = 1;

            }

            if ($scope.activationCode.attributes.promotion) {

                $scope.nextBillingPrice =
                    $scope.activationCode.attributes.promotion.attributes.total_price_string;

            } else {

                const appPrice = AppPricesRepository
                    .getSinglePrice(
                        $scope.activationCode.attributes.app,
                        runtime, devices,
                    );

                if (appPrice) {

                    $scope.nextBillingPrice = appPrice.attributes.price_string;

                } else {

                    const appIdForPrice = $scope.activationCode.attributes.app;
                    const rutimeForPrice = runtime;

                    AppPricesRestService
                        .getByAppIdAndRuntimeAndNumberOfUsers(
                            appIdForPrice, rutimeForPrice,
                            devices,
                        ).then((response) => {

                            AppPricesRepository.add(response.data.data);
                            if (response.data.data.length) {

                                const nextBillingPrice = response.data.data.find(price => price.id === `${appIdForPrice}_${rutimeForPrice}_${devices}`);

                                if (nextBillingPrice) {

                                    $scope.nextBillingPrice =
                                        nextBillingPrice.attributes.price_string;

                                }

                            }

                        });

                }

            }

            if ($scope.activationCode) {

                let nextBillingEvent = Util.deepFind($scope.activationCode, 'attributes.next_billing_event');
                const subscriptionType = Util.deepFind($scope.activationCode, 'attributes.subscription_type');
                const expirationDate = Util.deepFind($scope.activationCode, 'attributes.date_expire');

                if (!nextBillingEvent) {

                    switch (subscriptionType) {

                    case 'yearly':
                        nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                        break;
                    case 'monthly':
                        nextBillingEvent = moment(expirationDate).subtract(5, 'days');
                        break;
                    case 'annual':
                        nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                        break;
                    case 'monthly-trial':
                        nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                        break;
                    case 'annual-trial':
                        nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                        break;
                    default:
                        nextBillingEvent = expirationDate;

                    }

                }

                $scope.activationCode.formatted_date_expire = moment(expirationDate).format('L');
                $scope.activationCode.formatted_next_billing_event =
                    $scope.activationCode.attributes.customBillingDateForCMA || moment(nextBillingEvent).format('L');

            }

            const user = MeRepository.getMyUser();
            const userCountry = Util.deepFind(user, 'attributes.country');
            const userLanguage = Util.deepFind(user, 'attributes.language');
            const { phoneModalLanguage } = CWCONFIG || [];
            const isDach = (userCountry === 'DE' || userCountry === 'AT' || userCountry === 'CH') && phoneModalLanguage.find(lang => lang === userLanguage);
            const date = new Date();
            const currentHour = date.getHours();
            // Interval in which the modal with options should be displayed
            const startingHour = CWCONFIG.phoneModalStartingHour || 9;
            const endingHour = CWCONFIG.phoneModalEndingHour || 17;
            const phoneModalAcceptedValues = CWCONFIG.phoneModalVisibleValues || [];
            const activationCodes = ActivationCodesRepository.getAll();
            $scope.numberOfSubscriptions = activationCodes.length;
            const chatModalAcceptedValues = CWCONFIG.chatModalVisibleValues || [];
            $scope.canOfferChatSupport = false;
            $scope.filterName = $filter('friendName')(user);

            if ($scope.activationCode.relationships.app.data.id === 'aps20') {

                $scope.appIntegration = AppIntegrationsRepository
                    .getById('aps10');

            } else {

                $scope.appIntegration = AppIntegrationsRepository
                    .getById($scope.activationCode.relationships.app.data.id);

            }

            // If the user has multiple licenses
            // We need to check if those can be merged
            if (activationCodes.length >= 2) {

                const { bundles } = CWCONFIG.devices;
                const currentBundles = [];
                const appsCount = {};
                // Generate array with bundles ids on this account
                activationCodes.forEach((activationCode) => {

                    const appId = activationCode.attributes.app;
                    if (bundles.find(bundle => bundle === appId) &&
                        !currentBundles.find(bundle => bundle === appId)) {

                        currentBundles.push(appId);

                    }

                    // Count licenses to check for duplicates
                    if (!appsCount[appId]) {

                        appsCount[appId] = 1;

                    } else {

                        appsCount[appId] += 1;

                    }

                });

                let hasSameProduct = false;
                // Check for duplicated licenses
                Object.values(appsCount).forEach((value) => {

                    if (value > 1) {

                        hasSameProduct = true;

                    }

                });

                // Check if user has multiple licenses that can be merged
                if (currentBundles.length > 0) {

                    // If user has Prime, show the tooltip
                    const hasPrime = currentBundles.find(bundle => bundle === 'aps20') || currentBundles.find(bundle => bundle === 'aps10');

                    if (hasPrime) {

                        $scope.showMultipleLicensesTooltip = true;

                    } else if (hasSameProduct) {

                        $scope.showMultipleLicensesTooltip = true;

                    } else {

                        // If we find any other bundle
                        // We need to check if the user has another
                        // license for any component from the bundle
                        currentBundles.forEach((bundle) => {

                            const bundleIntegrations = AppIntegrationsRepository.getById(bundle);
                            const bundleComponents = bundleIntegrations.appComponents;

                            if (bundleComponents) {

                                activationCodes.forEach((activationCode) => {

                                    const activationCodeIntegration =
                                    AppIntegrationsRepository
                                        .getById(activationCode.attributes.app);
                                    const commonLicense = bundleComponents.find(app =>
                                        Util.compareString(Util.deepFind(app, 'attributes.resource.oeName'), Util.deepFind(activationCodeIntegration, 'attributes.resource.oeName'))
                                        || Util.compareString(Util.deepFind(app, 'attributes.name'), Util.deepFind(activationCodeIntegration, 'attributes.name'))
                                        || Util.compareString(Util.deepFind(app, 'attributes.prototype'), Util.deepFind(activationCodeIntegration, 'attributes.prototype')));

                                    if (commonLicense) {

                                        $scope.showMultipleLicensesTooltip = true;

                                    }

                                });

                            }

                        });

                    }

                }

            }

            /**
            * AV Pro campaign
            * get campaign param value from localstorage and check if this offer -10% discount
            */
            $scope.campaign = localStorage.getItem('offerAutoSubscription');
            $scope.isCampaignOfferDiscount = !!(($scope.campaign === 'auto-subscription-1' && !$scope.activationCode.attributes.promotion
                && ($scope.activationCode.attributes.app === 'aapd5' || $scope.activationCode.attributes.app === 'aapd0'))
            );

            let random;

            if (!sessionStorage.getItem('phoneModalValue')) {

                random = Math.floor(Math.random() * 10) + 1;
                sessionStorage.setItem('phoneModalValue', random);

            } else {

                random = parseInt(sessionStorage.getItem('phoneModalValue'), 0);

            }

            const isInAcceptedValues =
                    phoneModalAcceptedValues.find(value => value === random);

            $scope.canOfferPhoneSupport =
                isDach &&
                (currentHour >= startingHour && currentHour < endingHour) &&
                isInAcceptedValues;


            const optionsModalActions = () => {

                $scope.backToOptions = () => {

                    // a/b test animation
                    $scope.animateCardsEntrance();
                    $timeout(() => {

                        angular.element('#unsubscribe-modal').removeClass('animation');
                        angular.element('#options-modal').removeClass('options-modal-animation');

                    }, 0);

                    $scope.showPromotionModal = false;
                    $scope.showMonthlySwitch = false;
                    $scope.showPhoneModal = false;
                    $scope.showChatModal = false;
                    $scope.showOptions = true;

                    if (angular.element('#ze-snippet').length > 0) {

                        $scope.canOfferChatSupport = false;

                        if (!$scope.canOfferChatSupport &&
                            !$scope.canSwitchToMonthly &&
                            !$scope.canOfferChatSupport &&
                            !$scope.canOfferPhoneSupport) {

                            Util.closeModal();

                        }

                    }

                    Mixpanel.send('ConnectWeb Modal Button Click', {
                        Modal: 'Subscription Confirmation',
                        'Button Label': 'Back',
                        'Modal Detail': 'Unsubscribe Options',
                        Page: Util.getPageName(),
                    });

                };

                $scope.showPromotionScreen = () => {

                    // a/b test animation
                    if ($scope.isAnimationEnable) {

                        $scope.triggerAnimation('#unsubscribe-modal', 'animation');
                        $scope.triggerCardAnimation('promotion-option');
                        $timeout(() => {

                            $scope.showOptions = false;
                            $scope.showPromotionModal = true;

                            Mixpanel.send('ConnectWeb Modal Button Click', {
                                Modal: 'Subscription Confirmation',
                                'Button Label': 'Discount',
                                'Modal Detail': 'Unsubscribe Options',
                            });

                        }, $scope.animationDuration);

                    } else {

                        $scope.showOptions = false;
                        $scope.showPromotionModal = true;

                        Mixpanel.send('ConnectWeb Modal Button Click', {
                            Modal: 'Subscription Confirmation',
                            'Button Label': 'Discount',
                            'Modal Detail': 'Unsubscribe Options',
                        });

                    }

                    // Mixpanel.send('ConnectWeb Modal Button Click', {
                    //     Modal: 'Subscription Confirmation',
                    //     'Button Label': 'Discount',
                    //     'Modal Detail': 'Unsubscribe Options',
                    //     Page: Util.getPageName(),
                    // });

                };

                $scope.showPhoneScreen = () => {

                    if ($scope.isAnimationEnable) {

                        $scope.triggerAnimation('#unsubscribe-modal', 'animation');
                        $scope.triggerCardAnimation('phone-option');
                        $timeout(() => {

                            $scope.showOptions = false;
                            $scope.showPhoneModal = true;

                            Mixpanel.send('ConnectWeb Modal Button Click', {
                                Modal: 'Subscription Confirmation',
                                'Button Label': 'Phone support',
                                'Modal Detail': 'Unsubscribe Options',
                                Page: Util.getPageName(),
                            });

                        }, $scope.animationDuration);

                    } else {

                        $scope.showOptions = false;
                        $scope.showPhoneModal = true;

                        Mixpanel.send('ConnectWeb Modal Button Click', {
                            Modal: 'Subscription Confirmation',
                            'Button Label': 'Phone support',
                            'Modal Detail': 'Unsubscribe Options',
                            Page: Util.getPageName(),
                        });

                    }

                };

                $scope.showChatScreen = () => {

                    $scope.chatWidgetIsLoading = true;

                    if (angular.element('#ze-snippet').length === 0) {

                        const chatScriptUrl = 'https://static.zdassets.com/ekr/snippet.js?key=e574cc8f-ee6b-4fa8-ac52-e9ed8324d299';
                        const scriptTag = angular.element(document.createElement('script'));
                        scriptTag.attr('src', chatScriptUrl);
                        scriptTag.attr('id', 'ze-snippet');
                        angular.element('body').append(scriptTag);
                        $scope.triggerChatClickInterval =
                            setInterval($scope.triggerChatClick, 2000);

                    }

                    window.zESettings = {
                        webWidget: {
                            offset: { horizontal: '40px', vertical: '60px' },
                        },
                    };

                    eventManager.broadcast('zendesk-chat:started');

                    // a/b test animation
                    if ($scope.isAnimationEnable) {

                        $scope.triggerAnimation('#unsubscribe-modal', 'animation');
                        $scope.triggerCardAnimation('chat-option');

                        $timeout(() => {

                            $scope.showOptions = false;
                            $scope.showChatModal = true;

                            Mixpanel.send('ConnectWeb Modal Button Click', {
                                Modal: 'Subscription Confirmation',
                                'Button Label': 'Chat support',
                                'Modal Detail': 'Unsubscribe Options',
                                Page: Util.getPageName(),
                            });

                        }, $scope.animationDuration);

                    } else {

                        $scope.showOptions = false;
                        $scope.showChatModal = true;

                        Mixpanel.send('ConnectWeb Modal Button Click', {
                            Modal: 'Subscription Confirmation',
                            'Button Label': 'Chat support',
                            'Modal Detail': 'Unsubscribe Options',
                            Page: Util.getPageName(),
                        });

                    }

                };


                $scope.contactSupport = () => {

                    Mixpanel.send('ConnectWeb Modal Button Click', {
                        Modal: 'Subscription Confirmation',
                        'Button Label': 'Support',
                        'Modal Detail': 'Unsubscribe Options',
                    });

                };

                $scope.isLoading = !$scope.isLoading;

                // when subsription is off
                if ($scope.activationCode.attributes.subscription !== 1) {

                    Mixpanel.send('ConnectWeb Modal Open ', { Modal: 'Subscription Activation' });

                } else if ($scope.showFeedbackModalFirst) {

                    Mixpanel.send('ConnectWeb Modal Open ', { Modal: 'Unsubscribe Feedback' });

                } else {

                    Mixpanel.send('ConnectWeb Modal Open ', { Modal: 'Unsubscribe Offers' });

                }

                // when subsription is off

                $scope.$apply();

            };

            if (!$rootScope.cmaGBapplies && !$rootScope.cmaUSapplies) {

                $scope.showUnsubscribeFeedbackModal = true;

            } else {

                $scope.showUnsubscribeFeedbackModal = false;

            }

            let promisesArray = [];

            const currentAppId = $scope.activationCode.attributes.app;
            // Check if the current product has a discount
            const flexiblePromotionsPromise =
                    FlexiblePromotionsRestService
                        .getPromotionByActivationCode(key, subscriptionRuntime, currentAppId)
                        .then((response) => {

                            const currentRuntime = $scope.activationCode.attributes.runtime;

                            if (response.data.data.length > 0 &&
                                !$scope.activationCode.attributes.promotion) {

                                // Hide the discount option for AV 1 month
                                if (currentAppId === 'aapd5' || currentAppId === 'aapd0') {

                                    if (currentRuntime > 1) {

                                        // if (!localStorage.getItem('UnsubscribePromotionVariant')) {

                                        //     localStorage.setItem(
                                        //         'UnsubscribePromotionVariant',
                                        //         Math.floor(Math.random() * 2),
                                        //     );

                                        // }

                                        // const testGroup =
                                        // localStorage.getItem('UnsubscribePromotionVariant') === '0' ? 'control' : 'test';
                                        // $scope.testGroup = 'test';
                                        // Mixpanel.setCommonProperty('A/B Test Unsubscribe New Discount Phase 2', testGroup);

                                        // if (testGroup === 'control') {

                                        //     const promo10 = response.data.data.find(promo => promo.attributes.discount === 10);
                                        //     $scope.promotionDetails = promo10;
                                        //     FlexiblePromotionsRepository.add([promo10]);
                                        //     $scope.discountFreeDays = CWCONFIG.discountFreeDays10;

                                        // } else {

                                        const promo20 = response.data.data.find(promo => promo.attributes.discount === 20);
                                        $scope.promotionDetails = promo20;
                                        // FlexiblePromotionsRepository.add([promo20]);
                                        FlexiblePromotionsRepository.add(response.data.data);
                                        $scope.discountFreeDays = CWCONFIG.discountFreeDays20;

                                        // }

                                        $scope.canOfferDiscount = true;

                                    }

                                } else if (currentAppId === 'aps10' || currentAppId === 'aps20') {

                                    const promo20 = response.data.data.find(promo => promo.attributes.discount === 20);
                                    $scope.promotionDetails = promo20;
                                    // FlexiblePromotionsRepository.add([promo20]);
                                    FlexiblePromotionsRepository.add(response.data.data);
                                    $scope.discountFreeDays = CWCONFIG.discountFreeDays20;
                                    $scope.canOfferDiscount = true;

                                } else {

                                    // if (!localStorage.getItem('UnsubscribePromotionVariant')) {

                                    //     localStorage.setItem(
                                    //         'UnsubscribePromotionVariant',
                                    //         Math.floor(Math.random() * 2),
                                    //     );

                                    // }

                                    // const testGroup =
                                    //     localStorage.getItem('UnsubscribePromotionVariant') === '0' ? 'control' : 'test';
                                    // $scope.testGroup = testGroup;
                                    // Mixpanel.setCommonProperty('A/B Test Unsubscribe New Discount Phase 2', testGroup);

                                    // if (testGroup === 'control') {

                                    const promo10 = response.data.data.find(promo => promo.attributes.discount === 10);
                                    $scope.promotionDetails = promo10;
                                    FlexiblePromotionsRepository.add([promo10]);
                                    $scope.discountFreeDays = CWCONFIG.discountFreeDays10;

                                    // } else {

                                    //     const promo20 = response.data.data.find(promo => promo.attributes.discount === 20);
                                    //     $scope.promotionDetails = promo20;
                                    //     FlexiblePromotionsRepository.add([promo20]);
                                    //     $scope.discountFreeDays = CWCONFIG.discountFreeDays20;

                                    // }

                                    $scope.canOfferDiscount = true;

                                }

                                if ($scope.canOfferDiscount &&
                                    !$rootScope.cmaGBapplies && !$rootScope.cmaUSapplies) {

                                    $scope.showFeedbackModalFirst = true;

                                    if (!localStorage.getItem('UnsubscribeReasonVariant')) {

                                        localStorage.setItem(
                                            'UnsubscribeReasonVariant',
                                            Math.floor(Math.random() * 2),
                                        );

                                    }

                                    $scope.testGroup =
                                        localStorage.getItem('UnsubscribeReasonVariant') === '0'
                                            ? 'control'
                                            : 'test';

                                    Mixpanel.setCommonProperty(
                                        'A/B Test Unsubscribe Reasons Discount',
                                        $scope.testGroup,
                                    );

                                } else {

                                    $scope.showFeedbackModalFirst = false;

                                }

                                if ($scope.isCampaignOfferDiscount) {

                                    $scope.isLoadingAvCampaign = false;
                                    $scope.showDiscountScreen = true;

                                }

                            } else {

                                const enableSubscriptionDiscount =
                                    $scope.isCampaignOfferDiscount;

                                if (enableSubscriptionDiscount) {

                                    $scope.isCampaignOfferDiscount = false;

                                }

                            }


                        }).then(null, () => {

                            $scope.canOfferDiscount = false;

                        });

            if ($scope.activationCode.attributes.subscription === 1) {

                // Check if any support agent is available
                const { enableChatSupport } = CWCONFIG;
                const { chatSupportLanguages } = CWCONFIG;
                const checkChatLanguage = chatSupportLanguages.find(lang => lang === userLanguage);
                let chatSupportPromise;
                const chatDepartments = CWCONFIG.partnerConfig.support.chatDepartmentByLanguage;
                const departmentKey = chatDepartments ? chatDepartments[checkChatLanguage] : undefined;
                const checkAgentAvailability = !!(enableChatSupport && checkChatLanguage && departmentKey);

                if (checkAgentAvailability === true) {

                    chatSupportPromise =
                    $http({

                        method: 'GET',
                        url: 'https://support-surveys.avira.com/chat/agents_online',

                    }).then((response) => {


                        // Allow chat only if there are > 0 agents online for the user's language confirmed using the department key
                        if (response && response.data && departmentKey in response.data && response.data[departmentKey] > 0) {

                            if (angular.element('#ze-snippet').length === 0) {

                                $scope.canOfferChatSupport = true;
                                $scope.offerChatSupport = false;

                                let randomChatValue;

                                if (!localStorage.getItem('chatModalValue')) {

                                    randomChatValue = Math.floor(Math.random() * 10) + 1;
                                    localStorage.setItem('chatModalValue', randomChatValue);

                                } else {

                                    randomChatValue = parseInt(localStorage.getItem('chatModalValue'), 0);

                                }

                                const chatAcceptedValues =
                                chatModalAcceptedValues.find(value => value === randomChatValue);

                                if (chatAcceptedValues) {

                                    $scope.offerChatSupport = true;

                                }

                                Mixpanel.setCommonProperty('A/B Test Chat Visibility', $scope.offerChatSupport);

                            }

                        }

                    });

                }

                Promise.allSettled = (promises) => {

                    const mappedPromises = promises.map(p => p
                        .then(value => ({
                            status: 'fulfilled',
                            value,
                        }))
                        .catch(reason => ({
                            status: 'rejected',
                            reason,
                        })));
                    return Promise.all(mappedPromises);

                };


                if (checkAgentAvailability) {

                    promisesArray =
                        [flexiblePromotionsPromise, chatSupportPromise];

                } else {

                    promisesArray = [flexiblePromotionsPromise];

                }

            }

            Promise.allSettled(promisesArray).then(() => {

                optionsModalActions();

            });

            $scope.triggerChatClick = () => {

                const chatButtonIframe = angular.element('#launcher');

                if (chatButtonIframe) {

                    const chatButton = chatButtonIframe.contents().find('.wrapper-AtBcr');
                    chatButton.trigger('click');
                    $scope.chatWidgetIsLoading = false;
                    $scope.$apply();
                    clearInterval($scope.triggerChatClickInterval);
                    Mixpanel.send('ConnectWeb Chat Open');

                    if (window.zE) {

                        window.zE('webWidget', 'identify', {

                            name: $scope.filterName,
                            email: Util.deepFind(user, 'attributes.email'),

                        });

                    }

                }

            };

            $scope.formattedCreatedDate = moment($rootScope.dateABTest).format('L');
            $scope.formattedExpireDate = moment($scope.expireDate).format('L');

            // delete dateABTest variable when $scope is destroyed
            $scope.$on('$destroy', () => {

                delete $rootScope.dateABTest;

            });

            const surveyIsActive = Util.deepFind(CWCONFIG, 'features.unsubscribeSurvey.enabled');

            if (!$scope.activationCode) {

                Util.closeModal();
                return;

            }

            $scope.closeModal = () => {

                Util.closeModal();

            };

            /**
             * show custom unsubscribe modal with components for products that have relationships
             * some products do have an empty relationship and we show the default Unsubscribe modal
             */
            if ($scope.appIntegration.relationships.apps) {

                $scope.appComponents = [];
                const hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];
                // get the data for every component of the bundle
                $scope.appIntegration.relationships.apps.data.forEach((app) => {

                    if (!hiddenAppInBundleIds.find(id => app.id === id)) {

                        $scope.appComponents.push(AppIntegrationsRepository.getById(app.id));

                    }

                });

            }

            $scope.textFromProductCatalog = Util.deepFind($scope.appIntegration, 'attributes.resource.unsubscribetext');

            // send feedback
            $scope.sendFeedback = (buttonLabel) => {

                $scope.showTakeSurveyScreen = false;
                $scope.showSuccessScreen = true;

                Mixpanel.send('ConnectWeb Modal Button Click', {
                    Modal: 'Subscription Confirmation',
                    'Modal Detail': 'Unsubscribe Feedback',
                    'Button Label': buttonLabel,
                    Page: Util.getPageName(),
                });

            };

            $scope.closeModal = () => {

                Util.closeModal();

            };

            $scope.cancel = (subscriptionModalDetail, appId) => {

                const mixpanelDetails = {
                    Modal: 'Subscription Confirmation',
                    'Button Label': 'Cancel',
                    'Modal Detail': subscriptionModalDetail || '',
                    'Product ID': appId || '',
                    'Subscription Runtime': $scope.activationCode.attributes.runtime,
                    'Subscription Type': $scope.activationCode.attributes.subscription_type,
                    Page: Util.getPageName(),
                };

                Mixpanel.send('ConnectWeb Modal Button Click', mixpanelDetails);

                Util.closeModal();

            };

            $scope.confirm = (subscriptionModalDetail, appId, buttonLabel, enableWithDiscount) => {

                const subscriptionStatus = Util.deepFind($scope.activationCode, 'attributes.subscription');

                if (subscriptionStatus === 0) {

                    if (!$rootScope.cmaGBapplies && !$scope.acceptedRowTerms) {

                        if (!$scope.submitted) {

                            $scope.submitted = true;

                        }

                        return;

                    }

                    if ($rootScope.cmaGBapplies &&
                        (!$scope.acceptedGbTerms1 || !$scope.acceptedGbTerms2)) {

                        if (!$scope.submitted) {

                            $scope.submitted = true;

                        }

                        return;

                    }

                }

                $scope.loading = true;

                /*
                * enableWithDiscount parameter is not required
                * it is used to avoid sending the mixpanel event twice
                * when the user receive a discount for turning the subscription on
                */
                if (!enableWithDiscount) {

                    const mixpanelDetails = {
                        Modal: 'Subscription Confirmation',
                        'Button Label': buttonLabel || 'Confirm',
                        'Modal Detail': subscriptionModalDetail || '',
                        'Product ID': appId || '',
                        'Subscription Runtime': $scope.activationCode.attributes.runtime,
                        'Subscription Type': $scope.activationCode.attributes.subscription_type,
                        Page: Util.getPageName(),
                    };

                    Mixpanel.send('ConnectWeb Modal Button Click', mixpanelDetails);

                }

                /*
                * AV Pro Campaign
                * check if user enable appd5 or aadp0 subsciption
                * from campaign 'auto-subscription-0' or 'auto-subscription-1'
                * then sent a custom mixpanel event in order to
                * keep track of a total number of confirmation clicks
                */
                if (($scope.campaign === 'auto-subscription-0'
                    && (appId === 'aapd5' || appId === 'aapd0')
                    && subscriptionStatus === 0)
                    || subscriptionModalDetail === 'Apply discount and Enable Subscription') {

                    Mixpanel.send('ConnectWeb Total AutoSubscriptions Confirmation Click', {
                        Source: 'Subscriptions',
                        'Modal Detail': subscriptionModalDetail || '',
                        'Product ID': appId || '',
                        'Campaign Variant': $scope.campaign || '',
                    });

                }

                const payloadActivationCode = {
                    data: {
                        attributes: {
                            subscription: String(subscriptionStatus) === '0' ? '1' : '0',
                        },
                        relationships: {
                            provider: {
                                data: {
                                    type: 'providers',
                                    id: $window.appName,
                                },
                            },
                        },
                    },
                };

                ActivationCodeRestService
                    .updateAsync(key, payloadActivationCode)
                    .then((response) => {

                        $scope.loading = false;

                        ActivationCodesRepository.update(response.data.data);

                        // subscription has been canceled & unsubscribe survey is active
                        if (subscriptionStatus === 1 && surveyIsActive &&
                            $rootScope.hasUsCompliance) {

                            if ($scope.showUnsubscribeFeedbackModal) {

                                if ($scope.showFeedbackModalFirst) {

                                    $scope.showDiscountModal = false;
                                    $scope.showSuccessCancellationScreen = true;

                                } else {

                                    $scope.showBenefitsModal = false;
                                    $scope.showSuccessCancellationScreen = true;

                                }

                            } else {

                                $scope.surveyFlow = true;
                                $scope.showTakeSurveyScreen = true;

                            }

                        } else if (subscriptionModalDetail !== 'Apply discount and Enable Subscription') {

                            // subscription has been activated or unsubscribe survey is not active
                            // AV pro campaign
                            // do not close modal after discount applied and activation confirmation
                            Util.closeModal();

                        }

                    })
                    .then(null, (error) => {

                        const responseError =
                            (
                                error.data &&
                                error.data.errors &&
                                error.data.errors[0]
                            ) ? error.data.errors[0].code : false;

                        $scope.loading = false;

                        switch (responseError) {

                        case '21312':
                            Alert.error('cw.subscription.error.no-payment');
                            break;

                        case '21313':
                            Alert.error('cw.subscription.error.status_no_change_appstore');
                            break;

                        case '21315':
                            Alert.error('cw.subscription.error.no-payment');
                            break;

                        case '21316':
                            Alert.error('cw.subscription.error.status_no_change_google_play');
                            break;

                        case '21317':
                            Alert.error('cw.subscription.error.status_no_change_google_play');
                            break;

                        default:
                            Alert.error('cw.notification.system.error');

                        }

                    });

            };


            $scope.applyDiscount = (subscriptionModalDetail, appId) => {

                const promotionId = Util.deepFind($scope.promotionDetails, 'id');
                $scope.isLoading = !$scope.isLoading;
                $scope.showPromotionModal = false;
                $scope.expireDate = $filter('date')($scope.activationCode.attributes.date_expire);
                $scope.formattedNextBillingEvent =
                    $rootScope.customBillingDateForCMA || moment($scope.nextBillingEvent).format('L');

                if ($scope.showFeedbackModalFirst) {

                    $scope.showDiscountModal = false;

                }

                if ($scope.isCampaignOfferDiscount) {

                    $scope.showDiscountScreen = !$scope.showDiscountScreen;
                    $scope.isLoadingAvCampaign = !$scope.isLoadingAvCampaign;

                }

                const mixpanelDetails = {
                    Modal: 'Subscription Confirmation',
                    'Button Label': 'Confirm',
                    'Modal Detail': subscriptionModalDetail || '',
                    'Product ID': appId || '',
                    'Subscription Runtime': $scope.activationCode.attributes.runtime,
                    'Subscription Type': $scope.activationCode.attributes.subscription_type,
                    Page: Util.getPageName(),
                };

                Mixpanel.send('ConnectWeb Modal Button Click', mixpanelDetails);

                const payloadActivationCode = {
                    data: {
                        attributes: {
                            promotion_id: promotionId,
                        },
                        relationships: {
                            provider: {
                                data: {
                                    type: 'providers',
                                    id: $window.appName,
                                },
                            },
                        },
                    },
                };

                ActivationCodeRestService
                    .updateAsync(key, payloadActivationCode)
                    .then((response) => {

                        ActivationCodesRepository.update(response.data.data);

                        if (!$rootScope.promotionsTooltips[key]) {

                            $rootScope.promotionsTooltips[key] = true;

                        }

                        if ($scope.isCampaignOfferDiscount) {

                            $scope.isLoadingAvCampaign = false;
                            $scope.showDiscountScreen = false;
                            $scope.showOptions = false;
                            $scope.showDiscountAddedScreen = true;

                        } else {

                            $scope.isLoading = false;
                            $scope.showPromotionModal = false;
                            $scope.showOptions = false;
                            $scope.showDiscountAdded = true;

                        }

                        if (subscriptionModalDetail === 'Apply discount and Enable Subscription') {

                            // eslint-disable-next-line max-len
                            $scope.confirm(subscriptionModalDetail, $scope.activationCode.attributes.app, '', true);

                        } else {

                            const mixpanelPayload = {
                                Source: 'Subscriptions',
                                Modal: 'Cancel Subscription - Discount Applied',
                                Product: $scope.activationCode.attributes.app,
                                Page: Util.getPageName(),
                            };

                            Mixpanel.send('ConnectWeb Modal Open ', mixpanelPayload);

                        }

                    }).then(null, (error) => {

                        ErrorHandler.reportEvent('Apply Discount Subscription', error);
                        Alert.error('cw.notification.discount_not_applied.error');
                        Util.closeModal();

                    });

            };
            $scope.triggerAnimation = (id, className) => Util.triggerAnimation(id, className);
            $scope.triggerCardAnimation = async (id) => {

                const card = $window.document.getElementById(id);
                const optionsList = $window.document.getElementById('options-modal');
                // remove animation previously set in card entrance animation
                card.style.animation = 'unset';
                // clone the card
                const cardClone = card.cloneNode(true);
                // get the location of the card in the view
                const {
                    top,
                    left,
                    width,
                    height,
                } = card.getBoundingClientRect();
                const {
                    top: topParrent,
                    left: leftParrent,
                    width: widthParrent,
                    height: heightParrent,
                } = optionsList.getBoundingClientRect();

                // position the clone on top of the original
                cardClone.style.position = 'fixed';
                cardClone.style.top = `${top}px`;
                cardClone.style.left = `${left}px`;
                cardClone.style.width = `${width}px`;
                cardClone.style.height = `${height}px`;
                card.style.opacity = '0';
                card.parentNode.appendChild(cardClone);
                const otherThanCartIconElements = cardClone.querySelectorAll('.large-card > :not(.background-holder)');
                otherThanCartIconElements.forEach((element) => {

                    element.style.display = 'none';

                });

                // expand the clone card to the size of the card lists holder
                await angular.element('#options-modal').removeClass('options-modal-animation');
                await $scope.cardExpansion(cardClone, {
                    top: `${topParrent + 50}px`,
                    left: `${leftParrent}px`,
                    width: `${widthParrent}px`,
                    height: `${heightParrent}px`,
                });
                // set the display block so the content will follow the normal flow
                // in case the original card is not display block
                cardClone.style.display = 'block';

            };
            $scope.cardExpansion = (element, to, duration = 700) => new Promise((res) => {

                const cardIcon = element.querySelector('.background-holder');
                // remove the .background-holder class name to avoid fade out animation in css file
                cardIcon.classList.remove('background-holder');
                cardIcon.animate([
                    { // from
                        opacity: '1',
                        transform: 'scale(1)',
                    },
                    { // to
                        opacity: '0',
                        transform: 'scale(2)',
                    },
                ], { duration, fill: 'both' });
                element.animate([
                    { // to
                        top: to.top,
                        left: to.left,
                        width: to.width,
                        height: to.height,
                    },
                ], { duration, fill: 'both', easing: 'ease-in' });

                setTimeout(res, duration);

            });
            $scope.animateCardsEntrance = () => {

                const cardElements = angular.element('#options-list > .large-card');
                if (cardElements.length > 0 && $scope.isAnimationEnable) {

                    const duration = 0.5;
                    let i = 1;
                    for (let j = 0; j < cardElements.length; j += 1) {

                        i += 1;
                        angular.element(`#${cardElements[j].id}`).css('animationDelay', `${duration * i}s`);

                    }
                    angular.element('#unsubscribe-link').css('animationDelay', `${duration * (i + 1)}s`);

                }

            };

            $scope.goToCancelScreenRow = () => {

                $scope.showCancelScreenRow = true;
                $scope.showOptions = false;

                Mixpanel.send('ConnectWeb Modal Button Click', {
                    Modal: 'Subscription Confirmation',
                    'Button Label': 'Cancel now',
                    'Modal Detail': 'Unsubscribe Options',
                });

            };

            $scope.goToSurveyModal = () => {

                $scope.showSurveyModal = true;
                $scope.showOptions = false;

                Mixpanel.send('ConnectWeb Modal Button Click', {
                    Modal: 'Subscription Confirmation',
                    'Button Label': 'Cancel now',
                    'Modal Detail': 'Unsubscribe Feedback',
                });

            };


            $scope.sendFeedbackFromModal = (buttonLabel) => {

                if (!$scope.feedbackFocusedAutoRenew &&
                    !$scope.feedbackFocusedQuality &&
                    !$scope.feedbackFocusedSupport &&
                    !$scope.feedbackFocusedPrice &&
                    !$scope.feedbackFocusedOther) {

                    Mixpanel.send('ConnectWeb Modal Button Click', {
                        Modal: 'Subscription Confirmation',
                        'Modal Detail': 'Unsubscribe Feedback',
                        'Button Label': buttonLabel,
                        Page: Util.getPageName(),
                    });

                    if (buttonLabel === 'Auto-Renew') {

                        $scope.feedbackFocusedAutoRenew = true;

                    }

                    if (buttonLabel === 'Quality') {

                        $scope.feedbackFocusedQuality = true;

                    }

                    if (buttonLabel === 'Support') {

                        $scope.feedbackFocusedSupport = true;

                    }

                    if (buttonLabel === 'Price') {

                        $scope.feedbackFocusedPrice = true;

                    }

                    if (buttonLabel === 'Other') {

                        $scope.feedbackFocusedOther = true;

                    }

                }


            };

            $scope.goToBenefitsModal = () => {

                if ($scope.showFeedbackModalFirst) {

                    $scope.showBenefitsModal = true;
                    $scope.showOptions = false;

                } else {

                    $scope.showBenefitsModal = true;
                    $scope.showSurveyModal = false;

                }

                Mixpanel.send('ConnectWeb Modal Button Click', {
                    Modal: 'Subscription Confirmation',
                    'Button Label': 'Cancel now',
                    'Modal Detail': 'Unsubscribe Options',
                });

            };

            $scope.goToPromotionModal = () => {

                $scope.showDiscountModal = true;
                $scope.showBenefitsModal = false;

                Mixpanel.send('ConnectWeb Modal Button Click', {
                    Modal: 'Subscription Confirmation',
                    'Button Label': 'Cancel now',
                    'Modal Detail': 'Unsubscribe Offers',
                });

            };


            $scope.determineModalToOpen = () => {

                if ($scope.testGroup === 'control') {

                    $scope.goToPromotionModal();

                } else {

                    if (!$scope.feedbackFocusedAutoRenew && !$scope.feedbackFocusedPrice) {

                        const allPromotions = FlexiblePromotionsRepository.getAll();
                        $scope.promotionDetails = allPromotions.find(promo => promo.attributes.discount === 10);
                        $scope.discountFreeDays = CWCONFIG.discountFreeDays10;

                    }

                    $scope.goToPromotionModal();

                }

            };

        },

    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/subscriptionConfirmation.js